import { render, staticRenderFns } from "./rooms.vue?vue&type=template&id=4b31fc4d&scoped=true"
import script from "./rooms.vue?vue&type=script&lang=js"
export * from "./rooms.vue?vue&type=script&lang=js"
import style0 from "./rooms.vue?vue&type=style&index=0&id=4b31fc4d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b31fc4d",
  null
  
)

export default component.exports